import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useLayoutEffect, useRef } from 'react';

import { useUIState } from '../../../../app/App';
import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import { useTheme } from '../../../../theme/useTheme';

type Interface = { className: string };

const styles = css`
	position: absolute;
	display: flex;
	z-index: 100;
	transform: translate(50%, 0);
	right: 50%;
	user-select: none;
	pointer-events: none;
	transition: opacity 0.5s ease-in-out;
`;

const Component = ({ className }: Interface): ReactElement => {
	const ref = useRef<HTMLDivElement>(null);
	const { dateDelimiterStore } = useUIState();
	const theme = useTheme();
	useLayoutEffect(() => {
		if (theme.chat.dateDelimiterSticky.top) {
			const topValue = parseFloat(theme.chat.dateDelimiterSticky.top + '');
			!isNaN(topValue) && dateDelimiterStore.setStickyDelimiterTop(topValue);
		}
		if (ref.current) {
			dateDelimiterStore.setStickyDelimiterRef(ref.current);
		}
	}, [dateDelimiterStore, theme.chat.dateDelimiterSticky.top]);

	return (
		<div
			className={className}
			ref={ref}
			css={css`
				div& {
					opacity: ${dateDelimiterStore.isVisibleDelimiter ? 1 : 0};
				}
			`}
		>
			{dateDelimiterStore.currentText}
		</div>
	);
};

const DateDelimiterSticky = styled(observer(Component))(
	({
		theme: {
			chat: { dateDelimiterSticky },
		},
	}: {
		theme: Theme;
	}) => dateDelimiterSticky,
	styles
);

export { DateDelimiterSticky };
